import styles from './styles.module.css';
import cn from 'clsx';

type Props = {
  title: string;
  price: string | number;
  description?: string;
  currencySymbol?: string;
};
function PaymentItem({title, price, description, currencySymbol}: Props) {
  return (
    <div className={cn(styles.paymentBox__item, 'checkout-summary-box__item')}>
      <div
        className={cn(
          styles.paymentBox__itemInfoContainer,
          'checkout-summary-box__item-info-container',
        )}
      >
        <div
          className={cn(
            styles.paymentBox__itemInfo,
            'text-sm checkout-summary-box__item-info',
          )}
        >
          {title}
        </div>
        {description && (
          <div
            className={cn(
              styles.paymentBox__itemDescription,
              'checkout-summary-box__item-description',
            )}
          >
            {description}
          </div>
        )}
      </div>
      <div
        className={cn(
          styles.paymentBox__itemInfo,
          'text-md text-right checkout-summary-box__item-info',
        )}
      >
        {currencySymbol}
        {price}
      </div>
    </div>
  );
}

export {PaymentItem};
